import React from 'react';
import {TimeSpan} from "@sparkware/app-utils";
import {CyClass} from "../../../../common/cy-classes";
import {useServices} from "../../../react-hooks/use-services.hook";
import {GamblingSessionInfoTextBox, GamblingSessionInfoValueBox, GamblingSessionInfoWrapperBox} from "./boxes/gambling-session-info.box";

interface IGamblingSessionInfoProps {
    sessionDuration: TimeSpan;
    totalBets: number;
    totalWins: number;
}

export const GamblingSessionInfoComponent: React.FC<IGamblingSessionInfoProps> = (props) => {
    const services = useServices();
    return (<>
        <GamblingSessionInfoWrapperBox>
            <GamblingSessionInfoTextBox>{services.translation.translate("GAMBLING_SESSION_DATA_DURATION")}</GamblingSessionInfoTextBox>
            <GamblingSessionInfoValueBox className={CyClass('cy-gambling-session-duration')}>{props.sessionDuration.toHoursAndMinutesString()}</GamblingSessionInfoValueBox>
        </GamblingSessionInfoWrapperBox>

        <GamblingSessionInfoWrapperBox>
            <GamblingSessionInfoTextBox>{services.translation.translate("GAMBLING_SESSION_DATA_WIN_LOSS_SUMMARY")}</GamblingSessionInfoTextBox>
            <GamblingSessionInfoValueBox className={CyClass('cy-gambling-session-profit-loss')}>{services.currency.formatMoney(props.totalWins - props.totalBets)}</GamblingSessionInfoValueBox>
        </GamblingSessionInfoWrapperBox>

        <GamblingSessionInfoWrapperBox>
            <GamblingSessionInfoTextBox>{services.translation.translate("GAMBLING_SESSION_DATA_TOTAL_BETS")}</GamblingSessionInfoTextBox>
            <GamblingSessionInfoValueBox className={CyClass('cy-gambling-session-total-bets')}>{services.currency.formatMoney(props.totalBets)}</GamblingSessionInfoValueBox>
        </GamblingSessionInfoWrapperBox>
    </>);
}